import React, { useState, useEffect } from 'react';

const LaptopScreenAnimation = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!images || images.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds for a smooth transition

    return () => clearInterval(interval);
  }, [images]);

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div className="tw-relative tw-w-full tw-h-full">
      <img
        src="/images/Laptop_frame_r.png" // A full image of a laptop
        alt="Laptop frame"
        className="tw-w-full tw-h-full tw-object-cover tw-object-top tw-drop-shadow-2xl" // Align image to the top
      />
      {/* This div represents the screen area, positioned absolutely over the frame */}
      <div className="tw-absolute tw-top-[5%] tw-left-[8.6%] tw-w-[83%] tw-h-[83%] tw-overflow-hidden tw-bg-white">
        {images.map((src, index) => (
          <img
            key={src}
            src={src}
            alt={`Screen content ${index + 1}`}
            className={`tw-absolute tw-inset-0 tw-w-full tw-h-full object-fit tw-transition-opacity tw-duration-1000 tw-ease-in-out ${index === currentIndex ? 'tw-opacity-100' : 'tw-opacity-0'
              }`}
          />
        ))}
      </div>
    </div>
  );
};

export default LaptopScreenAnimation;
